module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/System/ExportPDF',
      "id": "__PrintPDF"
    }
  }, [_c('input', {
    attrs: {
      "name": "HTML",
      "id": "__PrintPDFHTML"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "Name",
      "id": "__PrintPDFName"
    }
  })]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f1e61b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1295
// module chunks = 169